'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import get from 'transmute/get';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIIconHolder from 'UIComponents/icon/UIIconHolder';
import UIUnauthedHubSpotUserAvatar from 'ui-addon-avatars/UIUnauthedHubSpotUserAvatar';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIImage from 'UIComponents/image/UIImage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { getIsRoundRobin, getHeaderType, getHeaderOptions } from 'MeetingsLib/utils/utils';
import { getBookInfo as getBookInfoSelector, getOffline as getOfflineSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getIsFetchingPublicAvailability, getIsFetchingCompanyName, getMeetingsCancelStatus } from 'MeetingsLib/selectors/RequestStatusSelectors';
import { SUCCEEDED } from 'MeetingsBase/constants/RequestStatusTypes';
import UserProfile from 'MeetingsBase/models/UserProfile';
var ProfileHeader = createReactClass({
  displayName: "ProfileHeader",
  propTypes: {
    // passed
    avatar: PropTypes.string,
    booked: PropTypes.bool.isRequired,
    cancelling: PropTypes.bool,
    headline: PropTypes.string,
    profile: PropTypes.instanceOf(UserProfile).isRequired,
    // loaded
    companyName: PropTypes.string,
    isFetchingCompanyName: PropTypes.bool,
    isFetchingPublicAvailability: PropTypes.bool,
    cancelRequestStatus: PropTypes.string,
    linkType: PropTypes.string,
    offline: PropTypes.bool,
    isRescheduling: PropTypes.bool
  },
  getDefaultHeadline: function getDefaultHeadline() {
    var _this$props = this.props,
        profile = _this$props.profile,
        companyName = _this$props.companyName,
        linkType = _this$props.linkType,
        offline = _this$props.offline,
        isFetchingCompanyName = _this$props.isFetchingCompanyName;
    var isRoundRobin = getIsRoundRobin(linkType);

    if (isRoundRobin && isFetchingCompanyName) {
      return null;
    }

    var suffix = offline ? 'offline' : 'online';
    var headerType = getHeaderType(isRoundRobin);
    var options = getHeaderOptions(isRoundRobin, companyName, profile);
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "prebook." + headerType + "." + suffix,
      options: options
    });
  },
  getCancelHeadline: function getCancelHeadline() {
    var _this$props2 = this.props,
        linkType = _this$props2.linkType,
        isFetchingCompanyName = _this$props2.isFetchingCompanyName,
        cancelRequestStatus = _this$props2.cancelRequestStatus;
    var isRoundRobin = getIsRoundRobin(linkType);

    if (isRoundRobin && isFetchingCompanyName) {
      return null;
    }

    if (cancelRequestStatus === SUCCEEDED) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "cancel.success.header"
      });
    }

    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "cancel.confirm.header"
    });
  },
  renderImage: function renderImage() {
    var _this$props3 = this.props,
        avatar = _this$props3.avatar,
        booked = _this$props3.booked,
        isFetchingPublicAvailability = _this$props3.isFetchingPublicAvailability;

    if (isFetchingPublicAvailability) {
      return this.renderSkeletonImage();
    }

    if (booked) {
      return this.renderBookedImage();
    }

    if (avatar) {
      return this.renderAvatarImage();
    }

    return this.renderUserImage();
  },
  renderBookedImage: function renderBookedImage() {
    var offline = this.props.offline;
    var name = offline ? 'successful-send' : 'success';
    return /*#__PURE__*/_jsx(UIIllustration, {
      name: name,
      width: "40%",
      "aria-hidden": true
    });
  },
  renderSkeletonImage: function renderSkeletonImage() {
    return /*#__PURE__*/_jsx("div", {
      "aria-hidden": true,
      className: "header-avatar",
      children: /*#__PURE__*/_jsx(UIIconHolder, {
        name: "contacts",
        size: 32,
        className: "skeleton-image"
      })
    });
  },
  renderAvatarImage: function renderAvatarImage() {
    return /*#__PURE__*/_jsx(UIImage, {
      className: "header-avatar avatar-image user-provided-avatar",
      src: this.props.avatar,
      shape: "circle",
      size: "responsive",
      "aria-hidden": true
    });
  },
  renderUserImage: function renderUserImage() {
    var profile = this.props.profile;
    var email = profile.email;
    if (!email) return this.renderSkeletonImage();
    return (
      /*#__PURE__*/
      // the avatar component doesn't support alt text, and doesn't provide useful additional info
      // so let's make this hidden to screen readers
      _jsx("div", {
        "aria-hidden": true,
        className: "header-avatar",
        children: /*#__PURE__*/_jsx(UIUnauthedHubSpotUserAvatar, {
          hubSpotUserEmail: email,
          className: "avatar-image",
          size: "lg",
          _isHasTooltip: false // experimental prop
          ,
          source: "meetings-public"
        })
      })
    );
  },
  renderMessage: function renderMessage() {
    var _this$props4 = this.props,
        headline = _this$props4.headline,
        booked = _this$props4.booked,
        cancelling = _this$props4.cancelling,
        offline = _this$props4.offline,
        isFetchingPublicAvailability = _this$props4.isFetchingPublicAvailability,
        isRescheduling = _this$props4.isRescheduling;

    if (isFetchingPublicAvailability) {
      return null;
    }

    if (cancelling) {
      return this.getCancelHeadline();
    }

    if (booked) {
      var suffix = offline ? 'offline' : 'online';
      var rescheduleSuffix = offline ? 'offlineReschedule' : 'onlineReschedule';
      var desiredSuffix = isRescheduling ? rescheduleSuffix : suffix;
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "summary.header." + desiredSuffix
      });
    }

    if (headline) {
      return headline;
    }

    return this.getDefaultHeadline();
  },
  renderHeadline: function renderHeadline() {
    var classes = 'headline m-top-4 m-bottom-0 m-x-1 overflow-y-auto' + (this.props.booked ? " success-header" : "");
    return /*#__PURE__*/_jsx(H2, {
      "aria-level": 1,
      className: classes,
      style: {
        alignSelf: 'stretch'
      },
      children: this.renderMessage()
    });
  },
  render: function render() {
    return /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      align: "center",
      alignSelf: "center",
      className: "profile-header text-center",
      children: [this.renderHeadline(), this.renderImage()]
    });
  }
});
export default connect(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,
    companyName: state.companyName,
    isFetchingCompanyName: getIsFetchingCompanyName(state),
    isFetchingPublicAvailability: getIsFetchingPublicAvailability(state),
    cancelRequestStatus: getMeetingsCancelStatus(state),
    linkType: get('linkType', getBookInfoSelector(state)),
    offline: getOfflineSelector(state),
    isRescheduling: state.isRescheduling
  };
})(ProfileHeader);